export default __webpack_public_path__ + "static/media/self.c809cfcc.jpg";